<template>
  <div class="flex flex-nowrap overflow-x-auto space-x-5 px-4 pb-4 pt-1">
    <draggable v-if="items.length" :list="items" class="flex flex-nowrap space-x-5" handle=".handle">
      <article-card
        v-for="(item, i) in items"
        v-bind="item"
        :key="i"
        :mode="mode"
        :selected="isActiveItem(item)"
        @click="$emit('click-item', item)"
        @delete="$emit('delete-item', item)"
      />
    </draggable>

    <div
      v-if="isEditMode"
      class="box-border flex flex-col flex-shrink-0 justify-center text-center w-65 h-85 rounded-4xl overflow-hidden p-6 bg-gray-200 cursor-pointer"
      @click="$emit('add')"
    >
      <p class="m-0 text-sm font-medium opacity-30">
        Добавить слайд
      </p>
    </div>
  </div>
</template>

<script>
import Draggable from 'vuedraggable'
import ArticleCard from './ArticleCard.vue'
import { useMode } from '../composables/mode'
import { useActiveItem } from '../composables/items'

export default {
  components: { Draggable, ArticleCard },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    mode: {
      type: String,
      default: 'view',
      validator: (val) => ['view', 'edit'].includes(val)
    },
    activeItem: {
      type: Object,
      default: null,
    }
  },
  setup(props) {
    const { isEditMode } = useMode(props)
    const { isActiveItem } = useActiveItem(props)

    return {
      isEditMode,
      isActiveItem,
    }
  }
}
</script>